import {createReducer, createAsyncThunk, createAction} from '@reduxjs/toolkit'
import orderDetailService from '../../services/order_details.service'
import visitService from '../../services/visit.service'
import {OrderDetailsHeaderProps} from '../../props_reusable/order_details'
import {Visit} from '../../props_reusable/visit'

export interface OrderDetailsState {
  header: {
    data: OrderDetailsHeaderProps | null
    error: boolean
    errorCode: string
  }
  visits: {
    data: Visit[] | null
    error: boolean
    errorCode: string
  }
}

const initialState: OrderDetailsState = {
  header: {
    data: null,
    error: false,
    errorCode: '',
  },
  visits: {
    data: null,
    error: false,
    errorCode: '',
  },
}

export const fetchOrderHeaderDetails = createAsyncThunk(
  'fetchOrderHeaderDetails',
  (arg, thunkApi) => {
    return orderDetailService
      .getOrderHeaderDetails<OrderDetailsHeaderProps>()
      .catch(error => {
        throw thunkApi.rejectWithValue(error.message)
      })
  },
)

export const fetchAllVisits = createAsyncThunk(
  'fetchAllVisits',
  (arg, thunkApi) => {
    return visitService
      .getAllVisits<{visitDetails: Visit[]}>()
      .then(data => data.visitDetails)
      .catch(error => {
        throw thunkApi.rejectWithValue(error.message)
      })
  },
)

export const resetOrderDetails = createAction('RESET_ORDER_DETAILS')

const orderDetailsReducer = createReducer(initialState, builder => {
  builder.addCase(fetchOrderHeaderDetails.fulfilled, (state, action) => {
    state.header = {
      data: action.payload,
      error: false,
      errorCode: '',
    }
  })
  builder.addCase(fetchOrderHeaderDetails.rejected, (state, action) => {
    state.header = {
      data: null,
      error: true,
      errorCode: action.payload as string,
    }
  })
  builder.addCase(fetchAllVisits.fulfilled, (state, action) => {
    state.visits = {
      data: action.payload,
      error: false,
      errorCode: '',
    }
  })
  builder.addCase(fetchAllVisits.rejected, (state, action) => {
    state.visits = {
      data: null,
      error: true,
      errorCode: action.payload as string,
    }
  })
  builder.addCase(resetOrderDetails, () => {
    return initialState
  })
})

export default orderDetailsReducer
